module.exports = __webpack_public_path__ + "img/sitting_person.9dad62bb.svg";